import { Avatar, Box, Button, Divider, Flex, Image, Stack, Text } from "@mantine/core";
import { IconArrowRight, IconBook2, IconUser } from "@tabler/icons-react";

export default function _CourseList5({component}) {

	return (
		<Stack
			component="section"
			mx={component?.customize_styles?.general_decoration?.margin_x}
			my={component?.customize_styles?.general_decoration?.margin_y}
			bd={`${component?.customize_styles?.general_decoration?.border_width} solid ${component?.customize_styles?.general_decoration?.border_color}`}
			bg={component?.customize_styles?.general_decoration?.background_color}
			px={component?.customize_styles?.general_decoration?.padding_x}
			py={component?.customize_styles?.general_decoration?.padding_y}
			style={{
				borderRadius: parseInt(component?.customize_styles?.general_decoration?.border_radius),
				boxShadow: `${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px #00000014`,
			}}
		>
			{/* ---------- course list ---------- */}
			<Stack>
				{component?.items?.map((course) => (
					<Stack
						gap={10}
						key={course?.id}
						align="center"
						bg={component?.customize_styles?.box_decoration?.background_color}
						mx={component?.customize_styles?.box_decoration?.margin_x}
						my={component?.customize_styles?.box_decoration?.margin_y}
						px={component?.customize_styles?.box_decoration?.padding_x}
						py={component?.customize_styles?.box_decoration?.padding_y}
						bd={`${component?.customize_styles?.box_decoration?.border_width} solid ${component?.customize_styles?.box_decoration?.border_color}`}
						style={{
							borderRadius:
								component?.customize_styles?.box_decoration?.border_radius,
						}}
					>
						<Box
							pos="relative"
							lh={0}
							ta={component?.customize_styles?.image_decoration?.alignment}
						>
							<Image
								display="inline-block"
								src={course?.thumbnail}
								// h={component?.customize_styles?.image_decoration?.height}
								// w={component?.customize_styles?.image_decoration?.width ?? "100%"}
								fit={component?.customize_styles?.image_decoration?.boxfit}
								radius={component?.customize_styles?.image_decoration?.radius}
							/>
							{/* --------- categories list --------- */}
							<Flex pos="absolute" top={10} right={10}>
								<Flex gap={3} align="center" wrap="wrap">
									{course?.categories?.map((category) => (
										<Text
											bg="#E7924D"
											px={14}
											py={5}
											key={category}
											fz={
												component?.customize_styles
													?.category_text_decoration?.font_size
											}
											c={
												component?.customize_styles
													?.category_text_decoration?.color
											}
											fs={
												component?.customize_styles
													?.category_text_decoration?.font_style
											}
											fw={
												component?.customize_styles
													?.category_text_decoration?.font_weight
											}
											ff={
												component?.customize_styles
													?.category_text_decoration?.font_family
											}
											ta={
												component?.customize_styles
													?.category_text_decoration?.text_align
											}
											lh={
												component?.customize_styles
													?.category_text_decoration?.text_height
											}
											lts={
												component?.customize_styles
													?.category_text_decoration?.letter_spacing
											}
											style={{
												textDecorationLine:
													component?.customize_styles
														?.category_text_decoration?.text_decoration,
												textDecorationColor:
													component?.customize_styles
														?.category_text_decoration
														?.decoration_color,
												textDecorationThickness:
													component?.customize_styles
														?.category_text_decoration
														?.decoration_thickness,
												borderRadius: "50px",
											}}
										>
											{category}
										</Text>
									))}
								</Flex>
							</Flex>
							{/* ---------- enroll button -------- */}
							<Button
								w={40}
								h={40}
								radius={"50%"}
								pos="absolute"
								bottom={-20}
								right={16}
								bg="#FFFFFF"
								py={11}
								px={11}
								style={{
									boxShadow: "0px 1px 3px 0px #1018281A",
								}}
							>
								<IconArrowRight color="#3C4AB4" size={35} />
							</Button>
						</Box>

						<Box w={"100%"}>
							{/* -------- course price information --------- */}
							<Flex gap={7} align="center" mt={16} mb={16}>
								<Text
									fs={
										component?.customize_styles?.sales_price_text_decoration
											?.font_style
									}
									fz={
										component?.customize_styles?.sales_price_text_decoration
											?.font_size
									}
									ff={
										component?.customize_styles?.sales_price_text_decoration
											?.font_family
									}
									fw={
										component?.customize_styles?.sales_price_text_decoration
											?.font_weight
									}
									c={
										component?.customize_styles?.sales_price_text_decoration
											?.color
									}
									lh={
										component?.customize_styles?.sales_price_text_decoration
											?.text_height
									}
									lts={
										component?.customize_styles?.sales_price_text_decoration
											?.letter_spacing
									}
									style={{
										textOverflow:
											component?.customize_styles?.sales_price_text_decoration
												?.text_overflow,
										textDecorationLine:
											component?.customize_styles?.sales_price_text_decoration
												?.text_decoration,
										textDecorationColor:
											component?.customize_styles?.sales_price_text_decoration
												?.decoration_color,
										textDecorationThickness:
											component?.customize_styles?.sales_price_text_decoration
												?.decoration_thickness,
									}}
								>
									${course?.course_price?.sale_price}
								</Text>
								<Text
									ta={
										component?.customize_styles?.regular_price_text_decoration
											?.text_align
									}
									ff={
										component?.customize_styles?.regular_price_text_decoration
											?.font_family
									}
									fs={
										component?.customize_styles?.regular_price_text_decoration
											?.font_style
									}
									fz={
										component?.customize_styles?.regular_price_text_decoration
											?.font_size
									}
									fw={
										component?.customize_styles?.regular_price_text_decoration
											?.font_weight
									}
									c={
										component?.customize_styles?.regular_price_text_decoration
											?.color
									}
									lh={
										component?.customize_styles?.regular_price_text_decoration
											?.text_height
									}
									lts={
										component?.customize_styles?.regular_price_text_decoration
											?.letter_spacing
									}
									style={{
										textDecorationLine:
											component?.customize_styles
												?.regular_price_text_decoration?.text_decoration,
										textDecorationColor:
											component?.customize_styles
												?.regular_price_text_decoration?.decoration_color,
										textDecorationThickness:
											component?.customize_styles
												?.regular_price_text_decoration
												?.decoration_thickness,
									}}
								>
									${course?.course_price?.regular_price}
								</Text>
							</Flex>
							<Text
								c={component?.customize_styles?.name_text_decoration?.color}
								ff={component?.customize_styles?.name_text_decoration?.font_family}
								fz={component?.customize_styles?.name_text_decoration?.font_size}
								fw={component?.customize_styles?.name_text_decoration?.font_weight}
								lh={component?.customize_styles?.name_text_decoration?.text_height}
								lts={
									component?.customize_styles?.name_text_decoration
										?.letter_spacing
								}
								lineClamp={2}
								style={{
									textOverflow:
										component?.customize_styles?.name_text_decoration
											?.text_overflow,
								}}
							>
								{course?.name}
							</Text>
							{/* ------- course registration information --------- */}
							<Flex my={14} align="center" gap={8}>
								<Flex align="center" gap={4}>
									<IconBook2 color="#5E6066" size={18} />
									<Text c="#5E6066" size="14px">
										11 Lessons
									</Text>
								</Flex>
								<Divider orientation="vertical" w={2} color="#B4B6B8" />
								<Flex align="center" gap={4}>
									<IconUser color="#5E6066" size={17} />
									<Text c="#5E6066" size="14px">
										{course?.total_students} Students
									</Text>
								</Flex>
							</Flex>
							{/* ----------- course author ---------- */}
							<Flex align="center" gap={5}>
								<Avatar
									c={component?.customize_styles?.avatar_decoration?.color}
									h={component?.customize_styles?.avatar_decoration?.height}
									w={component?.customize_styles?.avatar_decoration?.width}
									src={course?.author?.avatar}
									radius={component?.customize_styles?.avatar_decoration?.radius}
								/>
								<Flex gap={4} align="center">
									<Text c="#5E6066" size="14px">
										By
									</Text>
									<Text
										ff={
											component?.customize_styles?.author_text_decoration
												?.font_family
										}
										fw={
											component?.customize_styles?.author_text_decoration
												?.font_weight
										}
										fz={
											component?.customize_styles?.author_text_decoration
												?.font_size
										}
										c={
											component?.customize_styles?.author_text_decoration
												?.color
										}
										lh={
											component?.customize_styles?.author_text_decoration
												?.text_height
										}
										lts={
											component?.customize_styles?.author_text_decoration
												?.letter_spacing
										}
										style={{
											textOverflow:
												component?.customize_styles?.author_text_decoration
													?.text_overflow,
										}}
									>
										{course?.author?.name}
									</Text>
								</Flex>
							</Flex>
						</Box>
					</Stack>
				))}
			</Stack>
		</Stack>
	);
}
